// extracted by mini-css-extract-plugin
module.exports = {"container":"_80ad21f8ef--container--1AVYL","title":"_80ad21f8ef--title--3tAF_","description":"_80ad21f8ef--description--3QH3L"};